import Button from "../../../components/Comon/Button/Button";
import TextInput from "../../../components/Comon/TextInput/TextInput";
import HealthConcernRate from "../../../components/Survey/HealthConcernRate/HealthConcernRate";
import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import CheckboxThemed from "../../../components/Comon/CheckboxThemed";
import RadioThemed from "../../../components/Comon/RadioThemed";
import "./WellnessSurveySections.scss";

export default function WellnessSurveyOpenEndedScreen({
                                                          openEndedAnswers,
                                                          setOpenEndedAnswers = () => {},
                                                          errorsData,
                                                          settingsData,
                                                          clinicData,
                                                          themeColor,
                                                          handleOpenEndedNext = () => {},
                                                          handleOpenEndedPreviousScreen = () => {},
                                                      })
{
    const { i18n } = useTranslation();

    function handleSetOpenEndedAnswer(index,value){
        setOpenEndedAnswers(prevAnswers => prevAnswers.map((answer, i) => {
            if (i !== index) return answer;
            return {
                ...answer,
                value:value
            };
        }));
    }

    function getOpenEndedAnswer(index){
        return openEndedAnswers?.[index]?.value;
    }


    function validateAnswers() {
        const missingIndexes = [];

        (openEndedAnswers ?? []).forEach((item, index) => {
            if (!item?.mandatory) return;

            const value = item?.value;
            const type = item?.type;

            const isEmptyString = (v) => typeof v === 'string' && v.trim().length === 0;

            let isAnswered = true;

            if (type === 'open_text') {
                isAnswered = typeof value === 'string' && value.trim().length > 0;
            } else if (type === 'yes_no') {
                if (value === true || value === false) {
                    isAnswered = true;
                } else if (item?.boolean_not_sure) {
                    isAnswered = typeof value === 'string' && value.trim().length > 0;
                } else {
                    isAnswered = false;
                }
            } else if (type === 'multiple') {
                // Expect value to be an array of { label, value: boolean }
                const options = Array.isArray(value) ? value : [];
                isAnswered = options.some(opt => opt?.value === true);
            } else if (type === 'star_rating' || type === 'scale') {
                isAnswered = value !== undefined && value !== null && value !== '' && !isEmptyString(value);
            } else {
                // Fallback
                isAnswered = value !== undefined && value !== null && value !== '' && !isEmptyString(value);
            }

            if (!isAnswered) {
                missingIndexes.push(index);
            }
        });

        const missingNumbers = missingIndexes.map(i => i + 1);
        const missingLabel = missingNumbers.length
            ? `${i18n.t('pleaseAnswer')}`
            : '';

        return {
            isValid: missingIndexes.length === 0,
            missing: missingIndexes,
            missingLabel,
        };
    }

    const validation = validateAnswers();

    themeColor = themeColor ?? '#61849D';

    return <div style={{
        maxWidth:'800px',
        display:'flex',
        justifyContent:'center',
        alignItems:'stretch',
        flexDirection:'column'
    }}>
        <div style={{
            display:'flex',
            justifyContent:'center',
            alignItems:'center',
            flexDirection:'column',
            padding:'160px 0'
        }}>
            <div className={"headline"} style={{textAlign:'center', width:'100%'}}>
                {settingsData?.openEndedSectionTitle}
            </div>

            <div
                style={{ display:'flex', justifyContent:'center',alignItems:'center',marginBottom:'100px'}}
            >
                <a href={'#FORM'} style={{textDecoration:'none'}}>
                    <div className={"presentContainer"}>
                        <Button
                            color={themeColor}
                            mode={"small"}
                            text={i18n.t("startSurvey")}
                        />
                    </div>
                </a>

            </div>
        </div>



        <div
            id={'FORM'}
            className={"wellnessQuestionCard"}
            style={{
                width:'100%',
                display:'flex',
                justifyContent:'center',
                alignItems:'stretch',
                flexDirection:'column',
            }}
        >
            {
                openEndedAnswers?.map((item,index) => {
                    return <div
                        key={index}
                        className={"wellnessQuestionItem"}
                        style={{
                            display:'flex',
                            justifyContent:'center',
                            alignItems:'flex-start',
                            flexDirection:'column',
                            gap:'0px',
                        }}
                    >
                        <div className={"headline"} style={{fontSize:'40px', lineHeight:'54px', marginTop:0, marginBottom:'30px', textAlign:'left', width:'100%'}}>
                            {item?.question}
                            {item?.mandatory ? <span style={{color:"red"}}> *</span> : null}
                        </div>

                        {item?.type === 'open_text' &&
                            <div style={{width:'100%'}}>
                                <TextInput
                                    hideLabelIfNoLabel={true}
                                    hideErrorMessageIfNoMessage={true}
                                    rows={7}
                                    maxlength="450"
                                    mode={"grey"}
                                    placeholder={'Type here...'}
                                    type={"textarea"}
                                    setValue={(value) => handleSetOpenEndedAnswer(index, value)}
                                    value={getOpenEndedAnswer(index)}
                                />
                            </div>
                        }

                        {item?.type === 'yes_no' &&
                            <div
                                style={{
                                    width:'100%',
                                    display:'flex',
                                    flexDirection:'column',
                                    justifyContent:'stretch',
                                    alignItems:'center',
                                    gap:"15px"
                                }}
                            >
                                <div
                                    style={{
                                        cursor:'pointer',
                                        width:'100%',
                                        padding:'10px 30px',
                                        borderRadius: "25px",
                                        backgroundColor: "rgba(241, 237, 229, 1)",
                                        display:'flex',
                                        justifyContent:'flex-start',
                                        alignItems:'center',
                                        gap:"15px"
                                    }}
                                    onClick={() => handleSetOpenEndedAnswer(index, true)}
                                >
                                    <RadioThemed
                                        themeColor={themeColor}
                                        isChecked={item?.value === true}
                                    />
                                    <div>{i18n.t('Yes')}</div>
                                </div>

                                <div
                                    style={{
                                        cursor:'pointer',
                                        width:'100%',
                                        padding:'10px 30px',
                                        borderRadius: "25px",
                                        backgroundColor: "rgba(241, 237, 229, 1)",
                                        display:'flex',
                                        justifyContent:'flex-start',
                                        alignItems:'center',
                                        gap:"15px"
                                    }}
                                    onClick={() => handleSetOpenEndedAnswer(index, false)}
                                >
                                    <RadioThemed
                                        themeColor={themeColor}
                                        isChecked={item?.value === false}
                                    />
                                    <div>{i18n.t('No')}</div>
                                </div>

                                {
                                    item?.boolean_not_sure &&
                                    <div
                                        style={{
                                            width:'100%'
                                        }}
                                    >
                                        <TextInput
                                            hideLabelIfNoLabel={true}
                                            hideErrorMessageIfNoMessage={true}
                                            mode={"grey"}
                                            type={"text"}
                                            value={(getOpenEndedAnswer(index) !== false && getOpenEndedAnswer(index) !== true) ? getOpenEndedAnswer(index) : ''}
                                            setValue={(value) => handleSetOpenEndedAnswer(index, value)}
                                            placeholder={i18n.t("notSure")}
                                        />
                                    </div>
                                }

                            </div>
                        }

                        {item?.type === 'multiple' &&
                            <div
                                style={{
                                    width:'100%',
                                    display:'flex',
                                    flexDirection:'column',
                                    justifyContent:'stretch',
                                    alignItems:'center',
                                    gap:"15px"
                                }}
                            >
                                {
                                    item?.options?.map((option,optionIndex) => {
                                        return <div
                                            key={`${index}_${optionIndex}`}
                                            style={{
                                                cursor:'pointer',
                                                width:'100%',
                                                padding:'10px 30px',
                                                borderRadius: "25px",
                                                backgroundColor: "rgba(241, 237, 229, 1)",
                                                display:'flex',
                                                justifyContent:'flex-start',
                                                alignItems:'center',
                                                gap:"15px"
                                            }}
                                            onClick={() => {
                                                const isMultiple = item?.multi_select ?? false;
                                                const baseOptions = item?.value ?? item?.options;
                                                const currentOptions = getOpenEndedAnswer(index);

                                                // Ensure we always start from an array of option objects
                                                const baseWithValue = (currentOptions && Array.isArray(currentOptions))
                                                    ? currentOptions
                                                    : baseOptions.map(opt => ({
                                                        ...opt,
                                                        value: typeof opt.value === 'boolean' ? opt.value : false,
                                                    }));

                                                let newAnswers;

                                                if (isMultiple) {
                                                    // Multi-select: toggle only the clicked option, leave others as they are
                                                    newAnswers = baseWithValue.map((opt, baseOptionIndex) => {
                                                        if (baseOptionIndex !== optionIndex) return opt;
                                                        return {
                                                            ...opt,
                                                            value: !opt.value,
                                                        };
                                                    });
                                                } else {
                                                    // Single-select: behave like radio buttons but togglable
                                                    const clicked = baseWithValue[optionIndex];
                                                    const willSelect = !clicked?.value;

                                                    newAnswers = baseWithValue.map((opt, baseOptionIndex) => {
                                                        return {
                                                            ...opt,
                                                            value: willSelect && baseOptionIndex === optionIndex,
                                                        };
                                                    });
                                                }

                                                handleSetOpenEndedAnswer(index, newAnswers);
                                            }}
                                        >
                                            <CheckboxThemed
                                                themeColor={themeColor}
                                                isChecked={item?.value?.[optionIndex]?.value === true}
                                            />
                                            <div>{option?.label}</div>
                                        </div>
                                    })
                                }
                            </div>
                        }

                        {item?.type === 'star_rating' &&
                            <div style={{display:'flex',justifyContent:'center',alignItems:'center', width:'350px'}}>
                                <HealthConcernRate
                                    rate={getOpenEndedAnswer(index)}
                                    hasSpecificRate={true}
                                    themeColor={themeColor}
                                    i18n={i18n}
                                    setRate={(value) => handleSetOpenEndedAnswer(index,value)}
                                />
                            </div>
                        }

                        {item?.type === 'scale' &&
                            <>
                                <HealthConcernRate
                                    newScale={true}
                                    rate={getOpenEndedAnswer(index)}
                                    hasSpecificRate={false}
                                    themeColor={themeColor}
                                    i18n={i18n}
                                    leftOption={item?.lowScale}
                                    rightOption={item?.highScale}
                                    setRate={(value) => handleSetOpenEndedAnswer(index,value)}
                                />
                            </>
                        }

                    </div>
                })
            }


            <div
                style={{ display:'flex', flexDirection:'column', justifyContent:'center',alignItems:'center', marginTop:'60px'}}
            >
                <div
                    className={"presentContainer"}
                    style={{width:'360px'}}
                    onClick={() => {
                        if (validation.isValid) {
                            handleOpenEndedNext();
                        } else {
                            const el = document.getElementById('FORM');
                            el?.scrollIntoView({ behavior: 'smooth', block: 'start' });
                        }
                    }}
                >
                    <Button
                        color={themeColor}
                        mode={"small"}
                        text={i18n.t("submit")}
                        disabled={!validation.isValid}
                    />
                </div>

                {
                    !validation.isValid ? <div style={{textAlign:'center', color:"red", marginTop:'10px'}}>{validation.missingLabel}</div> : null
                }

                <div style={{color:'gray',textAlign:'center',textDecoration:'underline',marginTop:'15px', cursor:'pointer'}} onClick={() => handleOpenEndedPreviousScreen() }>
                    {i18n.t("previous")}
                </div>
            </div>

        </div>
    </div>
}
